module.exports = __webpack_public_path__ + "images/dig-naagriks.b5f8c346.webp";